import UINanoProgress from 'UIComponents/progress/UINanoProgress';
import styled, { theme } from '../../utils/Styling';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedList from 'I18n/components/FormattedList';
import ACIcon from '../icon/ACIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import { Children } from 'react';
import UIBadge from 'UIComponents/badge/UIBadge';
import { CertificationIcon } from 'foundations-assets';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ThumbnailOverlay = styled.div.withConfig({
  displayName: "ACThumbnailOverlay__ThumbnailOverlay",
  componentId: "sc-17mpr4x-0"
})(["height:100%;width:100%;color:", ";background-color:rgba(0,0,0,", ");"], theme.colors.OLAF, ({
  opacity
}) => 1 - opacity);
const ThumbnailHeader = styled.div.withConfig({
  displayName: "ACThumbnailOverlay__ThumbnailHeader",
  componentId: "sc-17mpr4x-1"
})(["position:absolute;top:0;left:0;width:100%;padding:12px;background:linear-gradient(180deg,rgba(0,0,0,0.6),transparent);display:flex;justify-content:space-between;"]);
const ThumbnailFooter = styled.div.withConfig({
  displayName: "ACThumbnailOverlay__ThumbnailFooter",
  componentId: "sc-17mpr4x-2"
})(["position:absolute;bottom:0;left:0;width:100%;padding:4px 12px;background-color:rgb(0,0,0,0.6);"]);
const ThumnailProgress = ({
  progress
}) => {
  return /*#__PURE__*/_jsx(UINanoProgress, {
    color: progress === 1 ? theme.colors.CALYPSO : theme.colors.SORBET,
    value: progress * 100
  });
};
const CardCompletedMessage = ({
  message = /*#__PURE__*/_jsx(FormattedMessage, {
    message: `academyCommon.progress.completed`
  })
}) => {
  return /*#__PURE__*/_jsxs(UIFlex, {
    align: "center",
    gap: 4,
    children: [/*#__PURE__*/_jsx(ACIcon, {
      color: theme.colors.CALYPSO,
      name: "checkmark"
    }), message]
  });
};
export const ThumbnailCategories = ({
  categories
}) => {
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(FormattedList, {
      lastWordConnector: ', ',
      twoWordsConnector: ', ',
      wordsConnector: ', ',
      children: categories.map(category => /*#__PURE__*/_jsx(FormattedMessage, {
        message: `academyCommon.categories.${category}`
      }, category))
    })
  });
};
const Footer = ({
  children,
  completed = false,
  progress,
  contentType,
  watermark
}) => {
  const isVideo = ['ACADEMY_VIDEO', 'VIDEO'].includes(contentType || '');
  const showFooter = completed || children || isVideo;
  if (showFooter) {
    return /*#__PURE__*/_jsx(ThumbnailFooter, {
      children: isVideo ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ThumnailProgress, {
          progress: completed ? 1 : 0
        }), /*#__PURE__*/_jsxs(Flex, {
          justifyContent: "space-between",
          children: [/*#__PURE__*/_jsxs(List, {
            inline: true,
            use: "inline-divided",
            children: [completed && /*#__PURE__*/_jsx(ListItem, {
              children: /*#__PURE__*/_jsx(CardCompletedMessage, {
                message: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "academyCommon.progress.watched"
                })
              })
            }), Children.map(children, (child, index) => /*#__PURE__*/_jsx(ListItem, {
              children: child
            }, index))]
          }), watermark]
        })]
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ThumnailProgress, {
          progress: progress
        }), /*#__PURE__*/_jsxs(UIFlex, {
          justify: "between",
          children: [completed && /*#__PURE__*/_jsx(CardCompletedMessage, {}), children]
        })]
      })
    });
  }
  return null;
};
const ACThumbnailOverlay = ({
  completed,
  remainingTime,
  contentType,
  categories,
  duration,
  children,
  header,
  footer,
  badge,
  watermark,
  contentTypeName
}) => {
  const progress = completed ? 1 : duration && remainingTime ? (duration - remainingTime) / duration : 0;
  return /*#__PURE__*/_jsxs(ThumbnailOverlay, {
    opacity: completed ? 0.6 : 1,
    children: [/*#__PURE__*/_jsx(ThumbnailHeader, {
      children: header !== null && header !== void 0 ? header : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs("div", {
          style: {
            maxWidth: '80%'
          },
          children: [/*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            gap: "100",
            children: [/*#__PURE__*/_jsx(Text, {
              color: "fill-surface-default",
              truncate: true,
              children: contentTypeName || /*#__PURE__*/_jsx(FormattedMessage, {
                message: `academyCommon.contentTypes.${contentType}`
              })
            }), contentType === 'CERTIFICATION' && /*#__PURE__*/_jsx(CertificationIcon, {
              color: "fill-primary-default",
              size: "200"
            })]
          }), categories && /*#__PURE__*/_jsx(ThumbnailCategories, {
            categories: categories
          })]
        }), badge && /*#__PURE__*/_jsx(UIBadge, {
          style: {
            height: 'fit-content'
          },
          use: "koala",
          children: badge
        })]
      })
    }), children, /*#__PURE__*/_jsx(Footer, {
      completed: completed,
      contentType: contentType,
      progress: progress,
      watermark: watermark,
      children: footer
    })]
  });
};
export default ACThumbnailOverlay;